import React from 'react';
import './ModalAddendas.css';

const ADDENDAS = [
  'Cinépolis',
  'Elektra',
  'Pemex',
  'Femsa',
  'Soriana',
  'Inbursa',
  'Comercial Mexicana',
  'Mabe',
  'Amazon',
  "L'Oréal",
  'Colgate',
  'Seguros GNP',
  'Ford',
  'Walmart',
  'AstraZeneca',
  'Prolec GE',
  'Chrysler',
  'Banorte',
  'Super Farmacia',
  'Autobuses ADO',
  'Coca-Cola',
  'Qualitas',
  'Chedraui',
  'Grupo Vitro',
  'Lala',
  'Cervecería Moctezuma',
  'Altos Hornos de México',
  'DuPont',
  'Audi',
  'Gayosso',
  "Pilgrim's",
  'San Luis Rassini',
  'Sanmina',
  'John Deere',
  'Nissan',
  'Volkswagen',
  'General Motors',
  'IMSS'
];

const ModalAddendas = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleGoToContact = (e) => {
    e.preventDefault();
    onClose();
    setTimeout(() => {
      const contactEl = document.querySelector('#contacto');
      if (contactEl) {
        const headerOffset = 70;
        const elementPosition = contactEl.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 50);
  };

  return (
    <div className="df-addendas-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="addendas-titulo">
      <div className="df-addendas-modal-backdrop" onClick={onClose} aria-hidden="true" />

      <div className="df-addendas-modal-dialog">
        {/* Cabecera Oficial */}
        <div className="df-addendas-modal-header">
          <div className="df-addendas-modal-header-titles">
            <h2 id="addendas-titulo" className="df-addendas-modal-title">
              Addendas disponibles
            </h2>
            <p className="df-addendas-modal-subtitle">
              Contamos con todas las addendas del mercado. Estas son algunas de ellas.
            </p>
          </div>

          <button
            type="button"
            className="df-addendas-modal-close-btn"
            onClick={onClose}
            aria-label="Cerrar modal"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        {/* Grilla Oficial con Scroll */}
        <div className="df-addendas-modal-scroll">
          <ul className="df-addendas-list-grid">
            {ADDENDAS.map((item, idx) => (
              <li key={idx} className="df-addendas-item-card">
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Pie Oficial del Modal */}
        <div className="df-addendas-modal-footer">
          <span className="df-addendas-footer-note">
            ¿No ves la addenda que necesitas? Te la desarrollamos.
          </span>
          <a
            href="#contacto"
            className="df-addendas-btn-contact"
            onClick={handleGoToContact}
          >
            Contáctanos
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModalAddendas;
